module.exports = __webpack_public_path__ + "img/banner3_5_en.fa288a8e.png";